'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = compose;

var _enforceFunction2 = require('./internal/_enforceFunction');

var _enforceFunction3 = _interopRequireDefault(_enforceFunction2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function composed(operations, arg) {
  var result = arg;
  for (var i = operations.length - 1; i >= 0; i--) {
    result = operations[i](result);
  }
  return result;
}

/**
 * Create a function that runs operations from right-to-left.
 *
 * `compose` is _not_ curried.
 *
 * @example
 * const doubleAndTakeEvens = pipe(
 *   filter(n => n % 2 === 0),
 *   map(n => n * 2)
 * );
 *
 * doubleAndTakeEvens(List.of(1, 2, 3))
 * // returns List [ 2, 4, 6 ]
 *
 * @param  {Array<Function>} operations any number of unary functions.
 * @return {Function}
 */
function compose() {
  for (var _len = arguments.length, operations = Array(_len), _key = 0; _key < _len; _key++) {
    operations[_key] = arguments[_key];
  }

  operations.forEach(_enforceFunction3.default);
  return composed.bind(null, operations);
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/transmute/static-2.9/compose.js
// module id = 792
// module chunks = 2 3